import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface NavBadgeProps {
  count: number;
  /**
   * Elsődleges (zöld) háttéren, pl. a mobil menü aktív linkjén vagy a fülsáv pillján: a jelvény
   * a pill feliratának színét kapja háttérnek (világos módban fehér, sötétben sötétzöld), egyébként piros
   */
  active?: boolean;
  className?: string;
}

/**
 * Számláló egy navigációs címke mellett (fejléc, mobil menü, fülsáv).
 * Kitöltött, nem halvány: a `destructive` variáns áttetsző pirosa a szürke fülsávon
 * beleolvadt a háttérbe.
 */
export function NavBadge({ count, active = false, className }: NavBadgeProps) {
  return (
    <Badge
      variant="destructive"
      className={cn(
        "min-w-5 bg-destructive px-1.5 text-white tabular-nums",
        // A `dark:` is kell: a `destructive` változat `dark:bg-destructive/20`-a más variánscsoport,
        // a tailwind-merge nem ejti ki, és sötét módban a sima háttér fölé kerülne (zöld szám a
        // zöld pillen, áttetsző piros alapon: olvashatatlan)
        active && "bg-primary-foreground text-primary dark:bg-primary-foreground",
        className,
      )}
    >
      {count > 99 ? "99+" : count}
    </Badge>
  );
}
